// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"XM-z","cltLink":"YM-z","shippingDisclaimer":"ZM-z"};